import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import { gaEvents } from '../../analytics/events'
import { Link, withRouter } from 'react-router-dom'
import { getCurrencySign, shouldTranslateTo } from '../../utils/utils'
import { ActionButtons, Subtitle, Title } from '../Utils/CustomClasses'
import PhotoApp from './PhotoApp'
import EditEmailApp from './EditEmailApp'
import EditProfileApp from './EditProfileApp'
import EditProfileStage2App from './EditProfileStage2App'
import ChooseMembershipFeeApp from './ChooseMembershipFeeApp'
import FeePayAsYouChooseApp from './FeePayAsYouChooseApp'
import EditPhoneNumberApp from './EditPhoneNumberApp'
import ProofIdentityApp from './ProofIdentityApp'
import Cookies from 'universal-cookie'

const queryParams = new URLSearchParams(window.location.search)
const cookies = new Cookies()

const ProfileSection = styled.section`
  padding-top: 50px;
`

const CustomContainer = styled.div``

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: stretch;

  @media screen and (max-width: 700px) {
    flex-direction: column;
  }
`

const TaskListBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  padding: 20px;

  width: 30%;
  min-width: 280px;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
`

const SplitRow = styled.div`
  display: flex;
  justify-content: space-between;

  & > div {
    flex-basis: 50%;
  }
`

const SplitColumn = styled.div``

const SplitColumnRight = styled(SplitColumn)`
  text-align: right;

  span {
    font-size: 18px;
  }
`

const ProgressBar = styled.div`
  background-color: #ababab;
  border-radius: 4px;
  margin: 4px 0 0 0;
  overflow: hidden;
  width: 100%;
`

const Progress = styled.div`
  background-color: #0bac5d;
  height: 8px;
  width: ${(props) => (props.width ? props.width : '0%')};
`

const TaskTitleBox = styled.div`
  border-bottom: 3px solid #ababab;
  display: flex;
  justify-content: space-between;
  margin: 30px 0 0 0;
`

const TaskTitleBoxLeft = styled.div`
  width: -webkit-fill-available;
`

const TaskTitleBoxRight = styled.div`
  text-align: right;
  width: 60px;
`

const InfoImage = styled.img`
  margin: 0 0 2px 0;
  width: 16px;
`

const TaskListItemLink = styled(Link)`
  text-decoration: none;

  & hover {
    text-decoration: underline;
  }
`

const TaskListItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 14px 0 0 0;
`

const TaskListItemLeft = styled.div`
  width: 43px;
`

const TaskListItemMiddle = styled.div`
  width: -webkit-fill-available;
`

const TaskListItemRight = styled.div`
  text-align: right;
  width: 40px;
`

const CbImage = styled.img`
  width: 20px;
`

const ChevronImage = styled.img`
  width: 18px;
`

const PromoPanelMobileWrapper = styled.div`
  display: block;
  width: -webkit-fill-available;

  @media (min-width: 701px) {
    display: none;
  }
`

const PromoPanelLaptopWrapper = styled.div`
  display: block;
  width: -webkit-fill-available;

  @media (max-width: 700px) {
    display: none;
  }
`

const PromoPanelBox = styled.div`
  background-color: #fff;
  background-image: ${(props) =>
    props.imageUrl
      ? 'url(/images/profile/progress/' + props.imageUrl + ')'
      : 'url(/images/profile/progress/promo-1.png)'};
  background-size: cover;
  background-position: right;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: 1000px) {
    background-position: center;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
  }
`

const PromoPanelBody = styled.div`
  width: 100%;
  height: 100%;
  padding: 30px 255px 20px 20px;

  @media screen and (max-width: 1000px) {
    padding: 20px;
  }
`

const ProgressTracker = styled.div`
  width: 100%;
  text-align: center;

  & > img {
    width: 90%;
    margin: 0 auto;
    max-width: 470px;
  }

  @media screen and (max-width: 1000px) {
    padding: 10px 30px;

    & > img {
      width: 100%;
    }
  }

  @media screen and (min-width: 1200px) {
    text-align: left;

    & > img {
      margin: 0 0 0 50px;
    }
  }
`

const PromoText = styled.div`
  padding: 0 0 30px;
  width: 100%;

  & > h1 {
    max-width: 470px;
  }

  & > h2 {
    max-width: 470px;
  }

  & > button {
    width: 90%;
    margin: 45px auto 20px;
    max-width: 470px;
  }

  @media screen and (max-width: 700px) {
    & > button {
      max-width: 530px;
    }
  }

  @media screen and (max-width: 1000px) {
    & > h1 {
      margin-top: 25px;
    }
  }

  @media screen and (min-width: 1200px) {
    padding: 0 30px;
  }

  @media screen and (min-width: 1200px) {
    text-align: left;

    & > button {
      margin: 45px 20px 40px;
    }
  }
`

const ActionPanel = styled.div`
  background-color: #ffffff;
  margin-top: 40px;
  width: 100%;
`

const TitleBox = styled.div`
  background-color: #ff9900;
  padding: 7px 10px 7px 36px;

  @media (max-width: 767px) {
    padding: 7px 10px 7px 20px;
  }
`

const ProfileApp = (props) => {
  const [pageText, setPageText] = useState([])
  const [user, setUser] = useState([])
  const [profilePicState, setProfilePicState] = useState('pending')
  const [emailState, setEmailState] = useState('pending')
  const [profileInfoState, setProfileInfoState] = useState('pending')
  const [contributionState, setContributionState] = useState('pending')
  const [phoneState, setPhoneState] = useState('pending')
  const [idState, setIdState] = useState('pending')
  const [accountProgress, setAccountProgress] = useState('0')
  const [chosen, setChosen] = useState('')
  const [actionTitle, setActionTitle] = useState('')
  const [promoPanelStep, setPromoPanelStep] = useState('')
  const [currencySign, setCurrencySign] = useState('')
  const [showStepFromQueryString, setShowStepFromQueryString] = useState('')
  const [emailVerification, setEmailVerification] = useState(false)

  const actionRef = useRef(null)

  const actionTitles = {
    photo: `${pageText[2]}`,
    email: `${pageText[3]}`,
    profile: `${pageText[4]}`,
    profilestage2: `${pageText[32]}`,
    fee: `${pageText[5]}`,
    phone: `${pageText[7]}`,
    id: `${pageText[8]}`,
  }

  const progressSteps = {
    photo: 'photo',
    email: 'email',
    emailconf: 'emailconf',
    profile: 'profile',
    profilestage2: 'profilestage2',
    fee: 'fee',
    feestage2: 'feestage2',
    phone: 'phone',
    id: 'id',
    community: 'community',
  }

  useEffect(() => {
    setUser(props.auth.user)

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        props.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    getPageText('profile-app', language)
    getCurrency()
  }, [])

  useEffect(() => {
    if (queryParams.get('pfs')) {
      setShowStepFromQueryString(queryParams.get('pfs'))
    }
    calculateAccountProgressAndHiglighting()
  }, [pageText])

  const calculateAccountProgressAndHiglighting = () => {
    axios
      .get('/api/verify-account-status/profileapp')
      .then((response) => {
        const userData = {
          status: response.data.status,
        }
        props.auth.updateUser(userData)
      })
      .catch((err) => {
        console.log('Error getting account status: ', err)
      })

    var taskTally = 0
    var nextItemHighlighted = false

    if (props.auth.user.profilePhotoStatus === 'completed') {
      setProfilePicState('completed')
      taskTally += 1
    } else {
      setProfilePicState('current')
      setPromoPanelStep(progressSteps.photo)
      setChosen(progressSteps.photo)
      setChosenTitle(progressSteps.photo)
      nextItemHighlighted = true
    }

    if (props.auth.user.emailStatus === 'verified') {
      setEmailState('completed')
      taskTally += 1
    } else {
      if (nextItemHighlighted === false) {
        setEmailState('current')
        setPromoPanelStep(progressSteps.email)
        setChosen(progressSteps.email)
        setChosenTitle(progressSteps.email)
        nextItemHighlighted = true
      } else {
        setEmailState('standard')
      }
    }

    if (props.auth.user.introductionStatus === 'completed') {
      setProfileInfoState('completed')
      taskTally += 1
    } else {
      if (nextItemHighlighted === false) {
        setProfileInfoState('current')
        setPromoPanelStep(progressSteps.profile)
        setChosen(progressSteps.profile)
        setChosenTitle(progressSteps.profile)
        nextItemHighlighted = true
      } else {
        setProfileInfoState('standard')
      }
    }

    if (props.auth.user.membershipFeeStatus === 'completed') {
      setContributionState('completed')
      taskTally += 1
    } else {
      if (nextItemHighlighted === false) {
        setContributionState('current')
        setPromoPanelStep(progressSteps.fee)
        setChosen(progressSteps.fee)
        setChosenTitle(progressSteps.fee)
        nextItemHighlighted = true
      } else {
        setContributionState('standard')
      }
    }

    // Show enhance profile info once required steps are completed
    if (
      props.auth.user.profilePhotoStatus === 'completed' &&
      props.auth.user.emailStatus === 'verified' &&
      props.auth.user.introductionStatus === 'completed' &&
      props.auth.user.membershipFeeStatus === 'completed' &&
      props.auth.user.favoStatus !== 'completed'
    ) {
      setPromoPanelStep(progressSteps.profilestage2)
      setChosen(progressSteps.profilestage2)
      setChosenTitle(progressSteps.profilestage2)
      nextItemHighlighted = true
    }

    if (props.auth.user.proofIdentityStatus === 'completed') {
      setIdState('completed')
      taskTally += 1
    } else {
      if (nextItemHighlighted === false) {
        setIdState('current')
        setPromoPanelStep(progressSteps.id)
        setChosen(progressSteps.id)
        setChosenTitle(progressSteps.id)
        nextItemHighlighted = true
      } else {
        setIdState('standard')
      }
    }

    if (props.auth.user.phoneStatus === 'verified') {
      setPhoneState('completed')
      taskTally += 1
    } else {
      if (nextItemHighlighted === false) {
        setPhoneState('current')
        setPromoPanelStep(progressSteps.phone)
        setChosen(progressSteps.phone)
        setChosenTitle(progressSteps.phone)
        nextItemHighlighted = true
      } else {
        setPhoneState('standard')
      }
    }

    // Catch-all as all items have been completed
    if (nextItemHighlighted === false) {
      setPromoPanelStep(progressSteps.community)
      setChosen(progressSteps.community)
      setChosenTitle(progressSteps.community)
      nextItemHighlighted = true
    }

    setAccountProgress(Math.round((taskTally / 6) * 100))

    if (showStepFromQueryString) {
      setChosen(showStepFromQueryString)
      setChosenTitle(showStepFromQueryString)
      scrollIntoView()
    }
  }

  const choosePaymentStep1 = () => {
    setChosen(progressSteps.fee)
  }

  const choosePaymentStep2 = () => {
    setChosen(progressSteps.feestage2)
  }

  const setChosenTitle = (item) => {
    var titleVal = ''
    switch (item) {
      case progressSteps.photo:
        titleVal = actionTitles.photo
        break
      case progressSteps.email:
        titleVal = actionTitles.email
        break
      case progressSteps.profile:
        titleVal = actionTitles.profile
        break
      case progressSteps.profilestage2:
        titleVal = actionTitles.profilestage2
        break
      case progressSteps.fee:
        titleVal = actionTitles.fee
        break
      case progressSteps.phone:
        titleVal = actionTitles.phone
        break
      case progressSteps.id:
        titleVal = actionTitles.id
        break
      default:
        break
    }
    setActionTitle(titleVal)
  }

  const handleTaskItemClick = (e, item) => {
    e.preventDefault()
    setChosen(item)
    setChosenTitle(item)
    scrollIntoView()
  }

  const handleVisitCommunityClick = (e) => {
    e.preventDefault()
    window.open('/dashboard/community2', '_self')
  }

  const handleVisitHomestaysClick = (e) => {
    e.preventDefault()
    window.open('/search?seeking=homestays', '_self')
  }

  const handleCompleteLaterClick = (e) => {
    e.preventDefault()
    window.open('/dashboard/complete-later', '_self')
  }

  const scrollIntoView = () => {
    const actionPanel = actionRef.current
    const actionNode = actionPanel.querySelectorAll('div')[0]
    actionNode.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  }

  const TaskList = ({ u }) => {
    return (
      <TaskListBox>
        {/* Header */}
        <SplitRow>
          <SplitColumn>
            <Title
              size="17px"
              sizemd="17px"
              sizesm="17px"
              lineheight="105%"
              weight="700"
              margin="0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[0]}`,
              }}
            ></Title>
          </SplitColumn>
          <SplitColumnRight>
            {' '}
            <Title
              color="#0bac5d"
              size="44px"
              sizemd="44px"
              sizesm="44px"
              lineheight="100%"
              weight="700"
              margin="-5px 0 0 0"
              dangerouslySetInnerHTML={{
                __html: `${accountProgress}<span>%</span>`,
              }}
            ></Title>
          </SplitColumnRight>
        </SplitRow>
        {/* Account progress */}
        <ProgressBar>
          <Progress width={`${accountProgress}%`}></Progress>
        </ProgressBar>
        {/* Compulsory task list */}
        <TaskTitleBox>
          <TaskTitleBoxLeft>
            <Subtitle
              color="#818181"
              size="17px"
              sizemd="17px"
              sizesm="17px"
              lineheight="100%"
              weight="700"
              margin="0 0 4px 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[1]}`,
              }}
            />
          </TaskTitleBoxLeft>
          <TaskTitleBoxRight>
            {' '}
            {/*
                        <Link>
                            <InfoImage
                                src={"/images/profile/icon-info.svg"}
                                alt={"info"}
                            />
                        </Link>
                        */}
          </TaskTitleBoxRight>
        </TaskTitleBox>
        <TaskListItemLink
          onClick={(e) => handleTaskItemClick(e, progressSteps.photo)}
        >
          <TaskListItem>
            <TaskListItemLeft>
              <CbImage
                src={`/images/profile/icon-cb-${profilePicState}.svg`}
                alt={'checkbox'}
              />
            </TaskListItemLeft>
            <TaskListItemMiddle>
              <Subtitle
                color="#000"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="400"
                margin="1px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[2]}`,
                }}
              />
            </TaskListItemMiddle>
            <TaskListItemRight>
              <ChevronImage
                src={`/images/profile/icon-cv-${profilePicState}.svg`}
                alt={'info'}
              />
            </TaskListItemRight>
          </TaskListItem>
        </TaskListItemLink>
        <TaskListItemLink
          onClick={(e) => handleTaskItemClick(e, progressSteps.email)}
        >
          <TaskListItem>
            <TaskListItemLeft>
              <CbImage
                src={`/images/profile/icon-cb-${emailState}.svg`}
                alt={'checkbox'}
              />
            </TaskListItemLeft>
            <TaskListItemMiddle>
              <Subtitle
                color="#000"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="400"
                margin="1px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[3]}`,
                }}
              />
            </TaskListItemMiddle>
            <TaskListItemRight>
              <ChevronImage
                src={`/images/profile/icon-cv-${emailState}.svg`}
                alt={'info'}
              />
            </TaskListItemRight>
          </TaskListItem>
        </TaskListItemLink>
        <TaskListItemLink
          onClick={
            props.auth.user.profilePhotoStatus === 'completed' &&
            props.auth.user.emailStatus === 'verified' &&
            props.auth.user.introductionStatus === 'completed' &&
            props.auth.user.membershipFeeStatus === 'completed'
              ? (e) => handleTaskItemClick(e, progressSteps.profilestage2)
              : (e) => handleTaskItemClick(e, progressSteps.profile)
          }
        >
          <TaskListItem>
            <TaskListItemLeft>
              <CbImage
                src={`/images/profile/icon-cb-${profileInfoState}.svg`}
                alt={'checkbox'}
              />
            </TaskListItemLeft>
            <TaskListItemMiddle>
              <Subtitle
                color="#000"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="400"
                margin="1px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[4]}`,
                }}
              />
            </TaskListItemMiddle>
            <TaskListItemRight>
              <ChevronImage
                src={`/images/profile/icon-cv-${profileInfoState}.svg`}
                alt={'info'}
              />
            </TaskListItemRight>
          </TaskListItem>
        </TaskListItemLink>
        <TaskListItemLink
          onClick={(e) => handleTaskItemClick(e, progressSteps.fee)}
        >
          <TaskListItem>
            <TaskListItemLeft>
              <CbImage
                src={`/images/profile/icon-cb-${contributionState}.svg`}
                alt={'checkbox'}
              />
            </TaskListItemLeft>
            <TaskListItemMiddle>
              <Subtitle
                color="#000"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="400"
                margin="1px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[5]}`,
                }}
              />
            </TaskListItemMiddle>
            <TaskListItemRight>
              <ChevronImage
                src={`/images/profile/icon-cv-${contributionState}.svg`}
                alt={'info'}
              />
            </TaskListItemRight>
          </TaskListItem>
        </TaskListItemLink>
        {/* Optional task list */}
        <TaskTitleBox>
          <TaskTitleBoxLeft>
            <Subtitle
              color="#818181"
              size="17px"
              sizemd="17px"
              sizesm="17px"
              lineheight="100%"
              weight="700"
              margin="0 0 4px 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            />
          </TaskTitleBoxLeft>
          <TaskTitleBoxRight>
            {' '}
            {/*
                        <Link>
                            <InfoImage
                                src={"/images/profile/icon-info.svg"}
                                alt={"info"}
                            />
                        </Link>
                        */}
          </TaskTitleBoxRight>
        </TaskTitleBox>
        <TaskListItemLink
          onClick={(e) => handleTaskItemClick(e, progressSteps.id)}
        >
          <TaskListItem>
            <TaskListItemLeft>
              <CbImage
                src={`/images/profile/icon-cb-${idState}.svg`}
                alt={'checkbox'}
              />
            </TaskListItemLeft>
            <TaskListItemMiddle>
              <Subtitle
                color="#000"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="400"
                margin="1px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[8]}`,
                }}
              />
            </TaskListItemMiddle>
            <TaskListItemRight>
              <ChevronImage
                src={`/images/profile/icon-cv-${idState}.svg`}
                alt={'info'}
              />
            </TaskListItemRight>
          </TaskListItem>
        </TaskListItemLink>
        <TaskListItemLink
          onClick={(e) => handleTaskItemClick(e, progressSteps.phone)}
        >
          <TaskListItem>
            <TaskListItemLeft>
              <CbImage
                src={`/images/profile/icon-cb-${phoneState}.svg`}
                alt={'checkbox'}
              />
            </TaskListItemLeft>
            <TaskListItemMiddle>
              <Subtitle
                color="#000"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="400"
                margin="1px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[7]}`,
                }}
              />
            </TaskListItemMiddle>
            <TaskListItemRight>
              <ChevronImage
                src={`/images/profile/icon-cv-${phoneState}.svg`}
                alt={'info'}
              />
            </TaskListItemRight>
          </TaskListItem>
        </TaskListItemLink>
      </TaskListBox>
    )
  }

  const PromoPanel = (props) => {
    var imageUrl = ''
    var bodyText1 = ''
    var buttonText = ''
    var buttonAction = ''
    var emailVerification = false

    if (queryParams.get('emv') === 'y') {
      emailVerification = true
      gaEvents.eventGeneric(
        'form_submit',
        'submitted',
        'Email verification completed'
      )
    }

    switch (props.step) {
      case progressSteps.email:
        imageUrl = 'promo-5.png'
        bodyText1 = `${pageText[9]}`
        buttonText = `${pageText[10]}`
        buttonAction = progressSteps.email
        break
      case progressSteps.emailconf:
        imageUrl = 'promo-5.png'
        bodyText1 = `${pageText[11]}`
        buttonText = `${pageText[12]}`
        buttonAction = chosen
        break
      case progressSteps.profile:
        imageUrl = 'promo-6.png'
        bodyText1 = `${emailVerification ? pageText[11] + ' ' : ''}${
          pageText[13]
        }`
        buttonText = `${pageText[14]}`
        buttonAction = progressSteps.profile
        break
      case progressSteps.fee:
        imageUrl = 'promo-2.png'
        bodyText1 = `${pageText[15]}`
        buttonText = `${pageText[17]}`
        buttonAction = progressSteps.fee
        break
      case progressSteps.profilestage2:
        imageUrl = 'promo-3.png'
        bodyText1 = `${pageText[18]}`
        buttonText = `${pageText[19]}`
        buttonAction = progressSteps.profilestage2
        break
      case progressSteps.id:
        imageUrl = 'promo-8.png'
        bodyText1 = `${pageText[24]}`
        buttonText = `${pageText[25]}`
        buttonAction = progressSteps.id
        break
      case progressSteps.phone:
        imageUrl = 'promo-7.png'
        if (props.status === 'approvedfinal') {
          bodyText1 = `${pageText[26]}`
        } else {
          bodyText1 = `${pageText[30]}`
        }
        buttonText = `${pageText[27]}`
        buttonAction = progressSteps.phone
        break
      case progressSteps.community:
        imageUrl = 'promo-2.png'
        if (props.status === 'approvedfinal') {
          bodyText1 = `${pageText[28]}`
        } else {
          bodyText1 = `${pageText[30]}`
        }
        break
      default:
        imageUrl = 'promo-1.png'
        bodyText1 = `${emailVerification ? pageText[11] + ' ' : ''}${
          pageText[20]
        }`
        buttonText = `${pageText[21]}`
        buttonAction = progressSteps.photo
        break
    }
    return (
      <PromoPanelBox imageUrl={imageUrl}>
        <PromoPanelBody>
          {(promoPanelStep == progressSteps.email ||
            promoPanelStep == progressSteps.emailconf ||
            promoPanelStep == progressSteps.profile ||
            promoPanelStep == progressSteps.fee ||
            promoPanelStep == progressSteps.photo) && (
            <ProgressTracker>
              <img
                src={
                  promoPanelStep === progressSteps.profilestage2
                    ? '/images/profile/progress/progress-tracker-completed.png'
                    : '/images/profile/progress/progress-tracker.png'
                }
              />
            </ProgressTracker>
          )}
          <PromoText>
            <Subtitle
              color="#fff"
              size="24px"
              sizemd="22px"
              sizesm="22px"
              weight="400"
              margin="30px 20px 0 20px"
              dangerouslySetInnerHTML={{
                __html: `${bodyText1}`,
              }}
            />
            {(promoPanelStep === progressSteps.profilestage2 ||
              promoPanelStep === progressSteps.phone ||
              promoPanelStep === progressSteps.id ||
              promoPanelStep === progressSteps.community) && (
              <ActionButtons
                type="submit"
                padding="10px 10px"
                margin="40px 20px 20px"
                onClick={(e) => handleVisitCommunityClick(e)}
              >
                {pageText[23]}
              </ActionButtons>
            )}
            {promoPanelStep !== progressSteps.profilestage2 &&
              promoPanelStep !== progressSteps.community && (
                <ActionButtons
                  type="submit"
                  padding="10px 10px"
                  margin="40px 20px 20px"
                  onClick={(e) => handleTaskItemClick(e, buttonAction)}
                >
                  {buttonText}
                </ActionButtons>
              )}
            {promoPanelStep === progressSteps.community && (
              <ActionButtons
                type="submit"
                padding="10px 10px"
                margin="40px 20px 40px"
                onClick={(e) => handleVisitHomestaysClick(e)}
              >
                {pageText[29]}
              </ActionButtons>
            )}
            {/* Sneak peek into Circle button. Switched off
                            promoPanelStep === progressSteps.fee && (
                            <ActionButtons
                                background="#ff9900"
                                type="submit"
                                padding="10px 10px"
                                margin="40px 20px 20px"
                                onClick={(e) => handleCompleteLaterClick(e)}
                            >
                                {pageText[31]}
                            </ActionButtons>
                        )*/}
          </PromoText>
        </PromoPanelBody>
      </PromoPanelBox>
    )
  }

  if (pageText.length === 0 || !currencySign) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[22]}</span>
        </div>
      </div>
    )
  }
  return (
    <ProfileSection>
      <CustomContainer>
        <FlexRow>
          <PromoPanelMobileWrapper>
            <PromoPanel
              currency={currencySign}
              step={promoPanelStep}
              status={props.auth.user.status}
            />
          </PromoPanelMobileWrapper>
          <TaskList u={user} />
          <PromoPanelLaptopWrapper>
            <PromoPanel
              currency={currencySign}
              step={promoPanelStep}
              status={props.auth.user.status}
            />
          </PromoPanelLaptopWrapper>
        </FlexRow>
        {chosen !== progressSteps.community && (
          <FlexRow ref={actionRef}>
            <ActionPanel>
              <TitleBox>
                <Title
                  color="#fff"
                  size="22px"
                  sizemd="22px"
                  sizesm="22px"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `${actionTitle}`,
                  }}
                ></Title>
              </TitleBox>

              {chosen == progressSteps.photo ? (
                <PhotoApp
                  data={props}
                  onUpdate={calculateAccountProgressAndHiglighting}
                />
              ) : chosen == progressSteps.email ? (
                <EditEmailApp
                  data={props}
                  onUpdate={calculateAccountProgressAndHiglighting}
                />
              ) : chosen == progressSteps.profile ? (
                <EditProfileApp
                  data={props}
                  onUpdate={calculateAccountProgressAndHiglighting}
                />
              ) : chosen == progressSteps.profilestage2 ? (
                <EditProfileStage2App
                  data={props}
                  onUpdate={calculateAccountProgressAndHiglighting}
                />
              ) : chosen == progressSteps.fee ? (
                <ChooseMembershipFeeApp
                  data={props}
                  onUpdate={choosePaymentStep2}
                />
              ) : chosen == progressSteps.feestage2 ? (
                <FeePayAsYouChooseApp
                  data={props}
                  onUpdate={calculateAccountProgressAndHiglighting}
                  onBack={choosePaymentStep1}
                />
              ) : chosen == progressSteps.phone ? (
                <EditPhoneNumberApp
                  data={props}
                  search={props.search}
                  onUpdate={calculateAccountProgressAndHiglighting}
                />
              ) : chosen == progressSteps.id ? (
                <ProofIdentityApp
                  data={props}
                  onUpdate={calculateAccountProgressAndHiglighting}
                />
              ) : null}
            </ActionPanel>
          </FlexRow>
        )}
      </CustomContainer>
    </ProfileSection>
  )
}

export default withRouter(withSearch(withAuth(ProfileApp)))
